import { SettingsPermissions } from "@redotech/account-common/permissions";
import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import type { WaitState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

export const WaitDetails = memo(function WaitDetails({
  state,
  stepSelect,
  setState,
}: StepTypeDetailsProps<WaitState>) {
  const { t } = useTranslation();
  const canEditReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );

  const nextStepChange = useHandler((next: StepId | undefined) => {
    setState((state) => ({ ...state, next }));
  });
  const [numDays, setNumDays] = useState<string>("1");

  const inputChange = (value: string) => {
    setNumDays(value);
    setState((state) => ({ ...state, numDays: parseInt(value) }));
  };

  return (
    <>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Delay (days)")}
        </Text>
        <RedoTextInput
          min={1}
          placeholder={t("Enter number of days...")}
          setValue={inputChange}
          state={canEditReturnsSettings ? "default" : "readonly"}
          value={numDays}
        />
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Next step")}
        </Text>
        {stepSelect({ value: state.next, valueChange: nextStepChange })}
        {!state.next && (
          <Text fontSize="xs" textColor="error">
            {t("Required")}
          </Text>
        )}
      </Flex>
    </>
  );
});
